export enum LandingFormType {
  MAIN = "Landing",
  LOGIN = "Login",
  REGISTER = "Register",
  FORGOT_PASS = "Receive a Reset password link",
  RESET_PASS = "Apply new password",
}
